module.exports = __webpack_public_path__ + "static/media/heat.a36a8825.svg";